export const CACHE_TIME = 1000 * 60 * import.meta.env.VITE_CACHE_MINUTES
